module.exports = __webpack_public_path__ + "static/media/温度控制.217f5d5f.png";